/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Faq_Q1Inputs */

const en_fw_faq_q1 = /** @type {(inputs: Fw_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where can I watch the Firefly Wedding anime?`)
};

const zh_fw_faq_q1 = /** @type {(inputs: Fw_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁动画在哪里可以看？`)
};

/**
* | output |
* | --- |
* | "Where can I watch the Firefly Wedding anime?" |
*
* @param {Fw_Faq_Q1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_faq_q1 = /** @type {((inputs?: Fw_Faq_Q1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Faq_Q1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_faq_q1(inputs)
	return zh_fw_faq_q1(inputs)
});
export { fw_faq_q1 as "fw.faq.q1" }